import { create } from 'zustand';

type PrintAgentStatus = 'connected' | 'disconnected';

interface PrintAgentStore {
    status: PrintAgentStatus;
    setStatus: (status: PrintAgentStatus) => void;
}

export const usePrintAgentStore = create<PrintAgentStore>((set) => ({
    status: 'disconnected',
    setStatus: (status) => set({ status }),
}));
